import Axios from "axios";
import { ADMIN_CUSTOM_HEADER, BASE_URL } from "../../config/AppConfig";
import { API_ENDPOINTS } from "../../utils/ApiEndPoint";
import {
  DEFAULT_STATUS_CODE_SUCCESS,
  DEFAULT_STATUS_CODE_UNAUTHORIZED,
} from "../../utils/AppConstants";
import { decryptData } from "../../utils/AppFunctions";
import {
  getSessionToken,
  requestTokenFromOtherTabs,
  runWithRefreshLock,
  setSessionToken,
  whileRestoringSession,
} from "../../utils/AuthTokenStore";

interface ISessionTokenRefresh {
  token: string | null;
  isNewToken: boolean;
}

const requestNewAccessToken = async (): Promise<string | null> => {
  try {
    const response = await Axios.get(
      BASE_URL + "/" + API_ENDPOINTS.renew_access_token.url,
      {
        withCredentials: true,
        headers: {
          "Content-Type": "application/json",
          "x-custom-header": ADMIN_CUSTOM_HEADER,
        },
      }
    );
    const decryptedData =
      response.data?.code === DEFAULT_STATUS_CODE_SUCCESS
        ? decryptData(response.data.data)
        : null;
    return decryptedData ? JSON.parse(decryptedData).token : null;
  } catch (error) {
    if (
      Axios.isAxiosError(error) &&
      error.response?.status === DEFAULT_STATUS_CODE_UNAUTHORIZED
    ) {
      return null;
    }
    throw error;
  }
};

export const refreshSessionToken = (failedToken?: string) =>
  runWithRefreshLock<ISessionTokenRefresh>(async () => {
    const currentToken = getSessionToken();
    if (currentToken && currentToken !== failedToken) {
      return { token: currentToken, isNewToken: false };
    }
    const newToken = await requestNewAccessToken();
    if (newToken) setSessionToken(newToken);
    return { token: newToken, isNewToken: !!newToken };
  });

export const restoreSessionToken = () =>
  whileRestoringSession(async () => {
    if (await requestTokenFromOtherTabs()) return true;
    const { token } = await refreshSessionToken();
    return !!token;
  });
